/******/ (function(modules) { // webpackBootstrap
  /******/ 	// The module cache
  /******/ 	var installedModules = {};
  /******/
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
    /******/
    /******/ 		// Check if module is in cache
    /******/ 		if(installedModules[moduleId]) {
      /******/ 			return installedModules[moduleId].exports;
      /******/ 		}
    /******/ 		// Create a new module (and put it into the cache)
    /******/ 		var module = installedModules[moduleId] = {
      /******/ 			i: moduleId,
      /******/ 			l: false,
      /******/ 			exports: {}
      /******/ 		};
    /******/
    /******/ 		// Execute the module function
    /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ 		// Flag the module as loaded
    /******/ 		module.l = true;
    /******/
    /******/ 		// Return the exports of the module
    /******/ 		return module.exports;
    /******/ 	}
  /******/
  /******/
  /******/ 	// expose the modules object (__webpack_modules__)
  /******/ 	__webpack_require__.m = modules;
  /******/
  /******/ 	// expose the module cache
  /******/ 	__webpack_require__.c = installedModules;
  /******/
  /******/ 	// define getter function for harmony exports
  /******/ 	__webpack_require__.d = function(exports, name, getter) {
    /******/ 		if(!__webpack_require__.o(exports, name)) {
      /******/ 			Object.defineProperty(exports, name, {
        /******/ 				configurable: false,
        /******/ 				enumerable: true,
        /******/ 				get: getter
        /******/ 			});
      /******/ 		}
    /******/ 	};
  /******/
  /******/ 	// getDefaultExport function for compatibility with non-harmony modules
  /******/ 	__webpack_require__.n = function(module) {
    /******/ 		var getter = module && module.__esModule ?
      /******/ 			function getDefault() { return module['default']; } :
    /******/ 			function getModuleExports() { return module; };
    /******/ 		__webpack_require__.d(getter, 'a', getter);
    /******/ 		return getter;
    /******/ 	};
  /******/
  /******/ 	// Object.prototype.hasOwnProperty.call
  /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
  /******/
  /******/ 	// __webpack_public_path__
  /******/ 	__webpack_require__.p = "";
  /******/
  /******/ 	// Load entry module and return exports
  /******/ 	return __webpack_require__(__webpack_require__.s = 0);
  /******/ })
/************************************************************************/
/******/ ([
  /* 0 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    __webpack_require__(1);

    __webpack_require__(2);

    __webpack_require__(3);

    __webpack_require__(4);

    __webpack_require__(5);

    __webpack_require__(6);

    window.Peel = {};

    __webpack_require__(8);
    __webpack_require__(9);

    __webpack_require__(10);
    __webpack_require__(11);
    __webpack_require__(12);
    __webpack_require__(13);

    /***/ }),
  /* 1 */
  /***/ (function(module, exports) {

    // removed by extract-text-webpack-plugin

    /***/ }),
  /* 2 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    window.cartDown = function () {
      $('.ajax-cart').addClass('ajax-cart--active');
      $('.overlay').fadeIn(400);
    };

    window.cartUp = function () {
      $('.ajax-cart').removeClass('ajax-cart--active');
      $('.overlay').fadeOut(400);
    };

    $(document).ready(function () {
      /*
        Size Checker
    */
      window.windowSize = Number($('#size-check').css('z-index'));

      $(window).on('resize', debounce(function () {
        windowSize = Number($('#size-check').css('z-index'));
      }, 250));

      /*
        Navigation
    */
      $('.header-hamburger').on('click', function () {
        $('body, html').toggleClass('nav-active');
      });

      $('.hasDropdown').on('click', function (event) {
        $(this).next('.dropdown').addClass('active');
        $('body').addClass('dropdown-active');
      });

      $('.hasDropdown.hasSub').on('click', function (event) {
        $(this).next('.dropdown').addClass('active');
        $('body').addClass('dropdown-active-hasSub');
      });

      $('.dropdown-back-second').on('click', function (event) {
        $('body').removeClass('dropdown-active-hasSub');
      });

      $('.hasDropdown.hasSub.hasChildSub').on('click', function (event) {
        $(this).next('.dropdown').addClass('active');
        $('body').addClass('dropdown-active-hasChildSub');
      });

      $('.dropdown-back-third').on('click', function (event) {
        $('body').removeClass('dropdown-active-hasChildSub');
        $(this).parent().removeClass('active');
      });

      $('.dropdown-back').on('click', function (event) {
        if($(this).parent().hasClass("hasSub")){

        }else{
          $('body').removeClass('dropdown-active');
        }
        //$('.dropdown').removeClass('active');
        $(this).parent().removeClass('active');
      });



      $('.advancedDropdown').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-active');
      }, function () {
        $('.advanced-nav-dropdown').removeClass('active');
        $('body').removeClass('advanced-dropdown-active');
      });

      $('.advanced-nav-dropdown').hover(function () {
        if ($(this).hasClass('iphone')) {
          var index = 0;
        } else if ($(this).hasClass('android')) {
          var index = 1;
        } else if ($(this).hasClass('accessories')) {
          var index = 2;
        }

        $(this).addClass('active');
        $('body').addClass('advanced-dropdown-active');

        $('.advancedDropdown').eq(index).children('.anchor').addClass('active');
      }, function () {
        $(this).removeClass('active');
        $('.advancedDropdown .anchor').removeClass('active');
        $('body').removeClass('advanced-dropdown-active');
      });

      $('.advanced-nav-dropdown li').hover(function () {
        var index = $(this).index();
        var p = $(this).closest('.advanced-nav-dropdown');

        var index = p.index() - 3;
        var className = $(this).attr('data-id');

        var img = $('.' + className).addClass('active');
      }, function () {
        $('.advanced-nav-dropdown .right img').removeClass('active');
      });


      /*
        Nav Second
    */
      $('.advancedDropdown-second').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown-second').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');
      }, function () {
        $('.advanced-nav-dropdown-second').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });

      $('.advancedDropdown-second.strong-grip').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown-second').removeClass('active');
        $('.advanced-nav-dropdown-second.iPhone-Strong-Grip-dropdown').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');
      }, function () {
        $('.advanced-nav-dropdown-second.iPhone-Strong-Grip-dropdown').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });

      $('.advancedDropdown-second.bumper').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown-second').removeClass('active');
        $('.advanced-nav-dropdown-second.iPhone-Bumper-dropdown').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');
      }, function () {
        $('.advanced-nav-dropdown-second.iPhone-Bumper-dropdown').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });
      $('.advancedDropdown-second.magsafe').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown-second').removeClass('active');
        $('.advanced-nav-dropdown-second.iPhone-magsafe-dropdown').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');
      }, function () {
        $('.advanced-nav-dropdown-second.iPhone-magsafe-dropdown').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });



      $('.advanced-nav-dropdown-second').hover(function () {
        if ($(this).hasClass('iPhone-dropdown')) {
          var index = 0;
        } else if ($(this).hasClass('Android-dropdown')) {
          var index = 1;
        } else if ($(this).hasClass('iPhone-Strong-Grip-dropdown')) {
          var index = 2;
        }

        $(this).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');

        $('.advancedDropdown-second').eq(index).children('.anchor-second').addClass('active');
      }, function () {
        $(this).removeClass('active');
        $('.advancedDropdown-second .anchor-second').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });

      /*
        Nav Second Screen Protectors
    */
      $('.advancedDropdown-second-screen').hover(function () {
        var index = $(this).index();
        $('.advanced-nav-dropdown-second-scr').eq(index).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');
      }, function () {
        $('.advanced-nav-dropdown-second-scr').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });

      $('.advanced-nav-dropdown-second-scr').hover(function () {
        if ($(this).hasClass('iPhone-dropdown')) {
          var index = 0;
        } else if ($(this).hasClass('Android-dropdown')) {
          var index = 1;
        } else if ($(this).hasClass('accessories')) {
          var index = 2;
        }

        $(this).addClass('active');
        $('body').addClass('advanced-dropdown-second-active');

        $('.advancedDropdown-second-screen').eq(index).children('.anchor-second-scr').addClass('active');
      }, function () {
        $(this).removeClass('active');
        $('.advancedDropdown-second-screen .anchor-second-scr').removeClass('active');
        $('body').removeClass('advanced-dropdown-second-active');
      });


      /*
        Search Overlay
    */
      $('.header-search a').on('click', function () {
        $('body').addClass('search-active');
        $('.search-overlay input').focus();
      });

      $('.search-overlay .close').on('click', function () {
        $('body').removeClass('search-active');
      });

      /*
        Footer Mailing List
    */
      KlaviyoSubscribe.attachToForms('#lbb-mailing', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#footer-mailing', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#wallet-mailing', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#charger-mailing', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#notebook-mailing', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#new-peel-mailing', { hide_form_on_success: true });

      /* 
        Ajax Cart
    */
      $('.header-cart').on('click', function (event) {
        var cartPage = window.location.href.indexOf('cart') > 0;

        if (windowSize > 20 && !cartPage) {
          event.preventDefault();
          cartDown();
        } else {
          window.location = '/cart';
        }
      });

      $('.ajax-cart__header svg').on('click', function () {
        cartUp();
      });

      $('.overlay').on('click', function () {
        cartUp();
      });

      /*
        Lazyload Images
    */
      if ($('.lazy').length) {
        $('.lazy').Lazy({
          afterLoad: function afterLoad(element) {
            element.addClass('lazy-loaded');
          }
        });
      }

      /*
        Fridaybuy Initalization
    */
      window['friendbuy'] = window['friendbuy'] || [];
      window['friendbuy'].push(['widget', 'dsT-lQe']);

      /*
        Animations
    */
      if ($('.load-in-up').length) {
        $('body').addClass('active');
      }

      if ($('.fade-in-up').length) {
        $(window).on('scroll', throttle(function () {
          var position = window.pageYOffset + window.innerHeight;
          var blocks = document.querySelectorAll('.fade-in-up');
          var scroll = window.scrollY;

          blocks.forEach(function (el) {
            var offset = el.getBoundingClientRect().top + scroll + el.clientHeight - 300;
            if (position > offset) el.classList.add('active');
          });
        }, 200));
      }
    });

    /***/ }),
  /* 3 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    function fixedHeader() {
      var position = $(window).scrollTop();
      var minimum = $('.main').offset().top;
      var el = $('.product-fixed-header');
      var theClass = 'product-fixed-header--active';
      var hasClass = el.hasClass(theClass);

      if (position > minimum && !hasClass) {
        el.addClass(theClass);
      } else if (position < minimum && hasClass) {
        el.removeClass(theClass);
      }
    }

    $(document).ready(function () {
      if ($('.product-fixed-header').length) {
        $(window).on('resize', debounce(function () {
          fixedHeader();
        }, 250));

        $(window).on('scroll', throttle(function () {
          fixedHeader();
        }, 250));
      }

      // Add to cart
      $('.product-details__add-to-cart').on('click', function (event) {
        if (windowSize > 20) {
          event.preventDefault();

          var id = Number($(this).attr('data-id'));
          var quantity = Number($('.product-details__quantity').val());

          CartJS.addItem(id, quantity, {}, {
            success: function success(data, textStatus, jqXHR) {
              cartDown();
            }
          });
        }
      });

      // Quantity Down
      $('body').on('click', '.quantity-selector__minus', function () {
        var currentQuantity = Number($('.product-details__quantity').val());

        if (currentQuantity > 1) {
          var newQuantity = currentQuantity - 1;

          $('.product-details__quantity').val(newQuantity);
          $('.quantity-selector__quantity').text(newQuantity);
        }
      });

      // Quantity Up
      $('body').on('click', '.quantity-selector__plus', function () {
        var currentQuantity = Number($('.product-details__quantity').val());
        var newQuantity = currentQuantity + 1;

        $('.product-details__quantity').val(newQuantity);
        $('.quantity-selector__quantity').text(newQuantity);
      });
    });

    /***/ }),
  /* 4 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    $(document).ready(function () {
      // $('.home-slider').owlCarousel({
      //     autoplay: true,
      //     loop: true,
      //     margin: 0,
      //     nav: false,
      //     dots: true,
      //     items: 1,
      //     animateOut: 'fadeOut',
      //     mouseDrag: false,
      // })

      // Instagram Feed
      $.getJSON('https://api.instagram.com/v1/users/self/media/recent/?scope=public_content&access_token=2120067250.1677ed0.97123539db8f410f977ed8ca4ccf339f&callback=?', function (data) {
        var feed = data;

        if (feed['data']) {
          for (var i = 0; i < 5; i++) {
            var image_url = feed['data'][i]['images']['standard_resolution']['url'];
            var page = feed['data'][i]['link'];

            $('.home-instagram-block').eq(i).attr('href', page).attr('style', 'background-image: url("' + image_url + '");');
          }

          $('.home-instagram').show();
        }
      });

      KlaviyoSubscribe.attachToForms('#home-mailing-full', { hide_form_on_success: true });
      KlaviyoSubscribe.attachToForms('#home-mailing-mobile', { hide_form_on_success: true });
    });

    /***/ }),
  /* 5 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    function createPopup(url, title) {
      var strTitle = title;
      var screenLeft = window.screenLeft;
      var screenTop = window.screenTop;
      var width = window.innerWidth;
      var height = window.innerHeight;
      var left = width / 2 - 500 / 2 + screenLeft;
      var top = height / 2 - 400 / 2 + screenTop;
      var strParam = 'width=' + '500' + ',height=' + '400' + ',resizable=' + 'no,' + 'top=' + top + ', left=' + left;

      window.open(url, strTitle, strParam).focus();
    }

    $(document).ready(function () {
      $('.when-share__facebook, .when-share__twitter').on('click', function (e) {
        e.preventDefault();
        createPopup($(this).attr('href'));
      });
    });

    /***/ }),
  /* 6 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    var _browserCookies = __webpack_require__(7);

    var _browserCookies2 = _interopRequireDefault(_browserCookies);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

    // Retrieve two cookies
    var usCookie = _browserCookies2.default.get('peel-us');
    var euCookie = _browserCookies2.default.get('peel-eu');
    var country = _browserCookies2.default.get('peel-country');

    // Set globals with cookies if available
    window.inUS = usCookie == 'true' ? true : false;
    window.inEU = euCookie == 'true' ? true : false;

    var EUcountries = ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK'];

    var IP_API = 'https://get.geojs.io/v1/ip/geo.json';

    $(document).ready(function () {
      if (!country) {
        $.getJSON(IP_API, function (data) {
          if (data.country_code == 'US') {
            window.inUS = true;
            $('html').removeClass('not-in-us');
            $('body').addClass('in-us');
            _browserCookies2.default.set('peel-us', 'true');
          } else {
            for (var i = 0; i < EUcountries.length; i++) {
              if (data.country_code == EUcountries[i]) {
                window.inEU = true;
                $('body').addClass('in-eu');
                _browserCookies2.default.set('peel-eu', 'true');
                break;
              }
            }
          }

          _browserCookies2.default.set('peel-country', 'true');
        });
      } else {
        if (window.inUS) {
          $('html').removeClass('not-in-us');
          $('body').addClass('in-us');
        }
      }
    });

    /***/ }),
  /* 7 */
  /***/ (function(module, exports) {

    exports.defaults = {};

    exports.set = function(name, value, options) {
      // Retrieve options and defaults
      var opts = options || {};
      var defaults = exports.defaults;

      // Apply default value for unspecified options
      var expires  = opts.expires  || defaults.expires;
      var domain   = opts.domain   || defaults.domain;
      var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
      var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
      var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
      var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;

      // Determine cookie expiration date
      // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
      var expDate = expires ? new Date(
        // in case expires is an integer, it should specify the number of days till the cookie expires
        typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
        // else expires should be either a Date object or in a format recognized by Date.parse()
        expires
      ) : 0;

      // Set cookie
      document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
      .replace('(', '%28')
      .replace(')', '%29') +
        '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
        (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
        (domain   ? ';domain=' + domain     : '') +                                      // Add domain
        (path     ? ';path='   + path       : '') +                                      // Add path
        (secure   ? ';secure'               : '') +                                      // Add secure option
        (httponly ? ';httponly'             : '') +                                      // Add httponly option
        (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
    };

    exports.get = function(name) {
      var cookies = document.cookie.split(';');

      // Iterate all cookies
      while(cookies.length) {
        var cookie = cookies.pop();

        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');

        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));

        // Return cookie value if the name matches
        if (cookie_name === name) {
          return decodeURIComponent(cookie.slice(separatorIndex + 1));
        }
      }

      // Return `null` as the cookie was not found
      return null;
    };

    exports.erase = function(name, options) {
      exports.set(name, '', {
        expires:  -1,
        domain:   options && options.domain,
        path:     options && options.path,
        secure:   0,
        httponly: 0}
                 );
    };

    exports.all = function() {
      var all = {};
      var cookies = document.cookie.split(';');

      // Iterate all cookies
      while(cookies.length) {
        var cookie = cookies.pop();

        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');

        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

        // add the cookie name and value to the `all` object
        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
      }

      return all;
    };


    /***/ }),
  /* 8 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    /* global Peel, $, CartJS, parameterize */

    Peel.product = {
      initiated: false,
      listenersSet: false,
      activeClass: null,

      sliderSettings: {
        auto: true,
        margin: 0,
        nav: true,
        dots: true,
        items: 1,
        loop: true,
        lazyLoad: true,
        mouseDrag: false,
        autoplay: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn'
      },

      createOptions: function createOptions() {
        if (!this.initiated) {
          $($('.selector-wrapper').get().reverse()).each(function () {
            var option = $(this).children('label').text();

            if (option) {
              var optionL = parameterize(option.toLowerCase());
            } else {
              var optionL = 'default';
            }

            // Special Cases
            if (option.length === 0) {
              if (window.location.href.indexOf('iphone-se') > 0 || window.location.href.indexOf('wireless-charger') > 0 || window.location.href.indexOf('the-peel-wallet') > 0 || window.location.href.indexOf('note9-case') > 0 || window.location.href.indexOf('s10e-case') > 0 || window.location.href.indexOf('pixel-5-case') > 0 || window.location.href.indexOf('pixel-6-case') > 0 || window.location.href.indexOf('pixel-6-pro-case') > 0) {
                option = 'Color';
                optionL = 'color';
              } else if (window.location.href.indexOf('iphone-x-case') > 0 || window.location.href.indexOf('iphone-xr-case') > 0) {
                option = 'Color';
                optionL = 'color';
              } else if (window.location.href.indexOf('base') > 0) {
                option = 'Shape';
                optionL = 'shape';
              } else if (window.location.href.indexOf('pixel-2-peel-glass') > 0 || window.location.href.indexOf('pixel-3-peel-glass-screen-protector') > 0 || window.location.href.indexOf('pixel-4-peel-glass-screen-protector') > 0 || window.location.href.indexOf('pixel-3a-peel-glass-screen-protector') > 0 || window.location.href.indexOf('iphone-xs-peel-glass-screen-protector') > 0 || window.location.href.indexOf('iphone-11-pro-peel-glass-screen-protector') > 0 || window.location.href.indexOf('iphone-12-peel-glass-screen-protector') > 0 || window.location.href.indexOf('iphone-12-pro-peel-glass-screen-protector') > 0 || window.location.href.indexOf('lite') > 0 || window.location.href.indexOf('galaxy-s8-peel-glass-screen-protector') > 0 || window.location.href.indexOf('pixel-4a-peel-glass-screen-protector') > 0) {
                option = 'Model';
                optionL = 'model';
              } else if (window.location.href.indexOf('gift-card') > 0) {
                option = 'Amount';
                optionL = 'model';
              } else if (window.location.href.indexOf('note8-case') > 0) {
                option = 'Color';
                optionL = 'color';
              }
            }

            var optionClass = 'product-options__option--' + optionL;

            var options = $(this).find('option');

            $('.product-options').prepend('<div class="product-options__option ' + optionClass + '"><h3 class="product-options__heading">' + option + '</h3><span class="product-options__heading-label"></span><ul class="product-options__list clear"></ul></div>');

            options.each(function () {
              if($(this).text() == 'Samsung S20'){
                var text = 'S20';
              }else if($(this).text() == 'Samsung S20+'){
                var text = 'S20+';
              }else if($(this).text() == 'Samsung S20 Ultra'){
                var text = 'S20 Ultra';
              }else{
                var text = $(this).text();
              }
              var textClass = parameterize(text);

              if ($(this).prop('selected')) {
                $('.' + optionClass + ' ul').append('<li class="product-options__item product-options__item--' + textClass + ' product-options__item--selected">' + text + '</li>');

                if (optionL === 'color' || optionL === 'shape') {
                  $('.' + optionClass + ' .product-options__heading-label').text($(this).text());
                }
              } else {
                $('.' + optionClass + ' ul').append('<li class="product-options__item product-options__item--' + textClass + '">' + text + '</li>');
              }
            });
          });
          Peel.product.initiated = true;
        }
      },

      setActiveClass: function setActiveClass() {
        var newActiveClass = [];

        $('.product-options__item--selected').each(function () {
          var preText = $(this).text().replace('+', 'p');

          var text = parameterize(preText);

          newActiveClass.push(text);
        });

        newActiveClass = newActiveClass.join('-');

        this.activeClass = newActiveClass;
      },

      initSlider: function initSlider() {
        var sliderClass = 'product-sliders__slider--' + this.activeClass;

        $('.product-sliders__slider').hide();

        $('.' + sliderClass).show().owlCarousel(this.sliderSettings).trigger('to.owl.carousel', 0);
      },

      initBaseImage: function initBaseImage() {
        var sliderClass = 'base-images__image--' + this.activeClass;

        $('.base-images__image').hide();

        $('.' + sliderClass).show();
      },

      plusTitle: function plusTitle() {
        var optionText = this.activeClass.indexOf('plus') > 0 || this.activeClass.indexOf('edge') > 0 || this.activeClass.indexOf('xl') > 0 || $('.product-options__option--model .product-options__item--selected').text().indexOf('+') > 0;
        var el = $('.product-details__heading-plus').length;

        if (optionText && el) {
          $('.product-details__heading-plus').addClass('product-details__heading-plus--active');
        } else if (el) {
          $('.product-details__heading-plus').removeClass('product-details__heading-plus--active');
        }
      },

      optionsClick: function optionsClick() {
        if (!this.listenersSet) {
          $('body').on('click', '.product-options__option--model li', function () {
            var selectorIndex = $(this).closest('.product-options__option').index();
            var optionIndex = $(this).index();

            $('.product-options__option--model li').removeClass('product-options__item--selected');

            $(this).addClass('product-options__item--selected');
            console.log($(this).text());

            if($(this).text() == 'iPhone 8 Plus'){
              $('.product-options__item--red').hide();
              $('.product-options__item--midnight-green').show();
              $('.product-options__item--black ').css({'cssText': 'margin-left: 0px !important'});
            }else if($(this).text() == 'iPhone 8 / SE (2020)'){
              $('.product-options__item--midnight-green,.product-options__item--red').show();
              $('.product-options__item--black ').css({'cssText': 'margin-left: 0.3125rem !important'});
            }

            Peel.product.plusTitle();
            Peel.product.changeSelector(selectorIndex, optionIndex);
            Peel.product.setTopClass();
          });

          $('body').on('click', '.product-options__option--paper-type li', function () {
            var selectorIndex = $(this).closest('.product-options__option').index();
            var optionIndex = $(this).index();

            $('.product-options__option--paper-type li').removeClass('product-options__item--selected');

            $(this).addClass('product-options__item--selected');

            Peel.product.changeSelector(selectorIndex, optionIndex);
            Peel.product.setTopClass();
          });

          $('body').on('click', '.product-options__option--color li', function () {
            var selectorIndex = $(this).closest('.product-options__option').index();
            var optionIndex = $(this).index();

            $('.product-options__option--color li').removeClass('product-options__item--selected');

            $(this).addClass('product-options__item--selected');

            if ($('.product-options__option--color .product-options__heading-label').length) {
              var colorText = $(this).text();
              $('.product-options__option--color .product-options__heading-label').text(colorText);
            }

            Peel.product.changeSelector(selectorIndex, optionIndex);
            Peel.product.setTopClass();
          });

          Peel.product.listenersSet = true;
        }
      },

      baseOptionsClick: function baseOptionsClick() {
        if (!this.listenersSet) {
          $('body').on('click', '.product-options__option--shape li', function () {
            var selectorIndex = $(this).closest('.product-options__option').index();
            var optionIndex = $(this).index();

            $('.product-options__option--shape li').removeClass('product-options__item--selected');

            $(this).addClass('product-options__item--selected');

            $('.product-options__option--shape .product-options__heading-label').text($(this).text());

            var gif = $('.base-images__image').eq(optionIndex).children('img');
            var gifSrc = gif.attr('src');
            gif.attr('src', gifSrc);

            $('.base-images__video').attr('autoplay', false);
            $('.base-images__image').eq(optionIndex).children('video').get(0).play();

            Peel.product.changeSelector(selectorIndex, optionIndex);
            Peel.product.setTopClass();
          });

          Peel.product.listenersSet = true;
        }
      },

      changeSelector: function changeSelector(selectorIndex, optionIndex) {
        $('#productSelect-option-' + selectorIndex + ' option').prop('selected', false).eq(optionIndex).prop('selected', true).change();
      },

      setDescription: function setDescription() {
        $('.product-variant-descriptions__description').hide();

        $('.product-variant-descriptions__description--' + this.activeClass).show();
      },

      setTopClass: function setTopClass() {
        $('#product-top').attr('class', this.activeClass);
      },

      initBase: function initBase() {
        this.createOptions();
        this.setActiveClass();
        this.initBaseImage();
        // this.globalClicks()
        this.baseOptionsClick();
      },

      initChargers: function initChargers() {
        $('#product-top').attr('class', 'juice-bag');
        $('.product-sliders__slider--juice-bag').show().owlCarousel(Peel.product.sliderSettings);
        // this.globalClicks()
      },

      init: function init() {
        this.createOptions();
        this.optionsClick();
        this.setActiveClass();
        this.setTopClass();
        this.plusTitle();
        this.initSlider();
        this.setDescription();
      }
    };

    /***/ }),
  /* 9 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    window.productSelectCallback = function (_ref) {
      var variant = _ref.variant,
          money_format = _ref.money_format,
          product = _ref.product;

      if (variant) {

        if(variant.id == 8296127037497){
          $('.product-details__footer .product-details__looking-for.8-plus').show();
          $('.product-details__footer .product-details__looking-for.8-se').hide().removeClass("active");
          $('.product-details__footer .toggle-screen-protector').hide();
        }else if(variant.id == 8296069038137){
          $('.product-details__footer .product-details__looking-for.8-plus').hide();
          $('.product-details__footer .product-details__looking-for.8-se').show();
        }

        var compare_at_price = variant.compare_at_price,
            price = variant.price,
            available = variant.available,
            inventory_quantity = variant.inventory_quantity,
            id = variant.id;

        var metafields = variant_metafields[variant.id];

        //Handle bottom link 
        if (metafields.title.indexOf("Super Thin iPhone 12 Mini Case") >= 0){
          $('.variant_iPhone_12').hide();
          $('.variant_iPhone_12_mini').show();
        }else{
          $('.variant_iPhone_12_mini').hide();
          $('.variant_iPhone_12').show();
        }

        if (metafields.title.indexOf("Super Thin iPhone 12 Pro Max Case") >= 0){
          $('.variant_iPhone_12_pro').hide();
          $('.variant_iPhone_12_pro_max').show();
        }else{
          $('.variant_iPhone_12_pro_max').hide();
          $('.variant_iPhone_12_pro').show();
        }
        
         if (metafields.title.indexOf("iPhone 12 Mini Peel Glass Screen Protector") >= 0){
          $('.variant_iPhone_12_glass').hide();
          $('.variant_iPhone_12_mini_glass').show();
        }else{
          $('.variant_iPhone_12_mini_glass').hide();
          $('.variant_iPhone_12_glass').show();
        }
        
        if (metafields.title.indexOf("iPhone 12 Pro Max Peel Glass Screen Protector") >= 0){
          $('.variant_iPhone_12_pro_glass').hide();
          $('.variant_iPhone_12_pro_max_glass').show();
        }else{
          $('.variant_iPhone_12_pro_max_glass').hide();
          $('.variant_iPhone_12_pro_glass').show();
        }

		if (metafields.title.indexOf("Super Thin iPhone 13 Mini Case") >= 0){
          $('.variant_iPhone_13').hide();
          $('.variant_iPhone_13_mini').show();
        }else{
          $('.variant_iPhone_13_mini').hide();
          $('.variant_iPhone_13').show();
        }

        if (metafields.title.indexOf("Super Thin iPhone 13 Pro Max Case") >= 0){
          $('.variant_iPhone_13_pro').hide();
          $('.variant_iPhone_13_pro_max').show();
        }else{
          $('.variant_iPhone_13_pro_max').hide();
          $('.variant_iPhone_13_pro').show();
        }
        
        if (metafields.title.indexOf("iPhone 13 Mini Peel Glass Screen Protector") >= 0){
          $('.variant_iPhone_13_glass').hide();
          $('.variant_iPhone_13_mini_glass').show();
        }else{
          $('.variant_iPhone_13_mini_glass').hide();
          $('.variant_iPhone_13_glass').show();
        }
        
        if (metafields.title.indexOf("iPhone 13 Pro Max Peel Glass Screen Protector") >= 0){
          $('.variant_iPhone_13_pro_glass').hide();
          $('.variant_iPhone_13_pro_max_glass').show();
        }else{
          $('.variant_iPhone_13_pro_max_glass').hide();
          $('.variant_iPhone_13_pro_glass').show();
        }
        
        

        // Change Title
        if (metafields.title.length) {
          $('#product-title').html(metafields.title.replace("\n", ""));
        } else {
          $('#product-title').html(product.title);
        }

        // Change Description
        if (metafields.description.length) {
          $('#product-description').html(metafields.description).show();
        } else {
          $('#product-description').hide();
        }

        // Change Background
        if (metafields.slider_background.length) {
          $('#product-top').css('background-color', metafields.slider_background);
        }

        // Change Prices
        var formatted_price = Shopify.formatMoney(price, money_format);

        var formatted_compare = Shopify.formatMoney(compare_at_price, money_format);

        $('#product-price').html(formatted_price);
        $('#compare-at-price').html(formatted_compare);
		
        // Change Button Text
        if (available && inventory_quantity >= 1) {
          $('#BIS_trigger').hide();
          $('#add-to-cart').show();
          $('#add-to-cart').prop('disabled', false);
          $('#add-to-cart-text').html(metafields.button_text || 'Add To Cart');
          $('#product-available').removeClass('hide');
          $('#product-unavailable').addClass('hide');
          /*
          if (variant.title.indexOf("SE (2020)") >= 0 && metafields.ships_notice){
            $('#product-available').addClass('hide');
            $('#product-unavailable').removeClass('hide');
          }
          */
        } else if (available && inventory_quantity < 1) {
          $('#BIS_trigger').hide();
          $('#add-to-cart').show();
          $('#add-to-cart').prop('disabled', false);
          $('#add-to-cart-text').html(metafields.button_backorder_text || 'Backorder');
          $('#product-available').addClass('hide');
          $('#product-unavailable').removeClass('hide');
        } else if (!available) {
          // Discontinue - iPhone 6/6s LITE
          //if(variant.id == 30613519431 || variant.id == 31273042313299 || variant.id == 5210316161 || variant.id == 1163542069267 || variant.id == 42942285267 || variant.id == 42942285331 || variant.id == 32000360120403 || variant.id == 17971026395193 || variant.id == 12920432197689 || variant.id == 32750742087 || variant.id == 17971005292601){
          if(metafields.button_discontinued_text){  
          	$('#add-to-cart').prop('disabled', true);  
            $('#BIS_trigger').hide();
            $('#add-to-cart').show();
            $('.bis-reset').hide();
          }else{
            $('#BIS_trigger').show();
            $('#add-to-cart').hide();
          }
          //$('#add-to-cart').prop('disabled', true);        
          $('#add-to-cart-text').html('Discontinued');
          $('#product-available').addClass('hide');
          $('#product-unavailable').removeClass('hide');
        }

        // Change ship notice
        if (metafields.ships_notice) {
          //$('.product-availability').show();  
          $('#ships-notice-stock').html(metafields.ships_notice);
          $('#ships-notice').html(metafields.ships_notice);
        } else {
          //$('.product-availability').hide();
          $('#ships-notice').html('Sold out');
          $('#ships-notice-stock').html('In stock and ready to ship');
          
          $.get( 'https://lasaona.com/buypeel/get_inventory.php?function=get-inventory&variant-id='+variant.id ).done(function(data){
            if(data.success){
              console.log(data.inventory_levels);
              for (let i = 0; i < data.inventory_levels.length; ++i) {
                if(data.inventory_levels[i].location_id == 49558035 && data.inventory_levels[i].available <=0 ){
                  $('#product-available').addClass('hide');
                  $('#product-unavailable').removeClass('hide');
                  if(metafields.button_discontinued_text){  
                    $('#add-to-cart-text').html(metafields.button_discontinued_text);
                  }else{
                    $('#add-to-cart-text').html(metafields.button_backorder_text || 'Backorder');
                  }
                }
              }
            }else{
              console.log('Error! We can\'t get inventory.');
            }
          });
          
        }

        // Set data-id
        $('#add-to-cart').attr('data-id', id);

        // Special Case (charger white)
        if (id == 9998992670777) {
          $('.header').addClass('dark');
        } else {
          $('.header').removeClass('dark');
        }
      }
    };

    /***/ }),
  /* 10 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    /* global Peel, $, CartJS, uproduct */

    Peel.newUpsell = {
      uniq: function uniq(a) {
        var unique = a.reduce(function (a, b) {
          if (a.indexOf(b) < 0) a.push(b);
          return a;
        }, []);

        return unique;
      },

      buildForm: function buildForm() {

        var variants = uproduct.variants;
        var option1 = [];
        var option2 = [];
        var option3 = [];

        for (var i = 0; i < variants.length; i++) {
          if (variants[i].option1) option1.push(variants[i].option1);
          if (variants[i].option2) option2.push(variants[i].option2);
          if (variants[i].option3) option3.push(variants[i].option3);
        }

        if(uproduct.handle == 'iphone-8-screen-protector'){
          option1.push('iPhone SE (2020)');
        }

        option1 = this.uniq(option1);
        option2 = this.uniq(option2);
        option3 = this.uniq(option3);

        if (option1.length > 1) {
          var select = document.createElement('select');
          var options = '<option value="" disabled selected>Select ' + uproduct.options[0] + '</option>';

          for (var i = 0; i < option1.length; i++) {
            options += '<option value="' + option1[i] + '">' + option1[i] + '</option>';
          }

          select.setAttribute('class', 'unselected select-1 upsell-select');
          select.innerHTML = options;
          $('.upsell-form__add').append(select);
        }

        if (option2.length > 1) {
          var select = document.createElement('select');
          var options = '<option value="" disabled selected>Select ' + uproduct.options[1] + '</option>';

          for (var i = 0; i < option2.length; i++) {
            options += '<option value="' + option2[i] + '">' + option2[i] + '</option>';
          }

          select.setAttribute('class', 'unselected select-2 upsell-select');
          select.innerHTML = options;
          $('.upsell-form__add').append(select);
        }

        if (option3.length > 1) {
          var select = document.createElement('select');
          var options = '<option value="" disabled selected>Select ' + uproduct.options[2] + '</option>';

          for (var i = 0; i < option3.length; i++) {
            options += '<option value="' + option3[i] + '">' + option3[i] + '</option>';
          }

          select.setAttribute('class', 'unselected select-3 upsell-select');
          select.innerHTML = options;
          $('.upsell-form__add').append(select);
        }

        // var select = document.createElement('select')
        // var options = '<option value="" disabled selected>Quantity</option>'

        // for (var i = 1; i < 11; i++) {
        //     options += '<option value="' + i + '">' + i + '</option>'
        // }

        // select.setAttribute('class', 'unselected select-quantity upsell-quantity')
        // select.innerHTML = options
        // $('.upsell-form__add').append(select)
      },

      setListeners: function setListeners() {
        $('.upsell-form input[type="checkbox"]').on('change', function () {
          if ($(this).prop('checked')) {
            $('.upsell-form').addClass('upsell-form--checked');
          } else {
            $('.upsell-form').removeClass('upsell-form--checked');
          }
        });

        // $('.select-quantity').on('change', function() {
        //     var newQuantity = Number($(this).val())

        //     if (newQuantity > 1) {
        //         var cents = uproduct.price * newQuantity
        //         var newPrice = Shopify.formatMoney(cents, Shopify.money_format)

        //         $('.new .money').text(newPrice)

        //     }
        // })

        $('.unselected').on('change', function () {
          $(this).removeClass('unselected');
        });

        $('.upsell-buttons__checkout a').on('click', function (e) {
          if ($('#upsell').prop('checked')) {
            e.preventDefault();

            if (uproduct.variants.length === 1) {
              var upsell_id = uproduct.variants[0].id;
            } else {
              if($(".select-1.upsell-select").val() == 'iPhone SE (2020)' && uproduct.handle == 'iphone-8-screen-protector'){
                var upsell_id = 31976676819027;
              }else{
                var upsell_id = Peel.newUpsell.findId();
              }
            }

            // var quantity = Number($('.upsell-quantity').val())

            CartJS.addItem(upsell_id, 1, {}, {
              success: function success(data, textStatus, jqXHR) {
                window.location.href = '/checkout';
              },
              error: function error(jqXHR, textStatus, errorThrown) {
                console.log('Something went wrong');
              }
            });
          }
        });

        $('.upsell-buttons__upgrade a').on('click', function (e) {
          e.preventDefault();

          if (uproduct.variants.length === 1) {
            var upsell_id = uproduct.variants[0].id;
          } else {
            var upsell_id = Peel.newUpsell.findId();
          }

          $.getJSON('/cart.js', function(results) {
            var qtt_in_cart = 0;
            $.each(results.items, function(i, item) {
              if (item.id == upsell_id) {
                qtt_in_cart += item.quantity;
              }
            });
            var qtt_upgrade = 3 - qtt_in_cart;
            if(qtt_upgrade > 0){
              CartJS.addItem(upsell_id, qtt_upgrade, {}, {
                success: function success(data, textStatus, jqXHR) {
                  window.location.href = '/checkout?discount=3%2BTouchTools20%25OFF';
                },
                error: function error(jqXHR, textStatus, errorThrown) {
                  console.log('Something went wrong');
                }
              });
            }else{
              window.location.href = '/checkout?discount=3%2BTouchTools20%25OFF';
            }

          });

        });

      },

      findId: function findId() {
        var option1 = $('.select-1').length ? $('.select-1').val() : null;
        var option2 = $('.select-2').length ? $('.select-2').val() : null;
        var option3 = $('.select-3').length ? $('.select-3').val() : null;
        var variants = uproduct.variants;
        var id;
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];

          if (option1 === variant.option1 && option2 === variant.option2 && option3 === variant.option3) {
            id = variant.id;
            break;
          }
        }

        return id;
      },

      init: function init() {
        if (typeof uproduct !== 'undefined') {
          this.buildForm();
        }

        this.setListeners();
      }
    };

    $(document).ready(function () {
      Peel.newUpsell.init();
    });

    /***/ }),
  /* 11 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    /* global Peel, $, CartJS, upsellChargers, upsell6Glass, upsell7Glass */

    Peel.upsellDirector = {

      // check iP 12 Pro Max or 12 Mini?
      is12PM: false,
      is12MN: false,

      // check iP 11 Pro Max or XL?
      is11PM: false,
      isPixel3XL: false,
      isPixel3aXL: false,
      isPixel4XL: false,

      // In stock?
      g6Stock: true,
      g7Stock: true,
      g8Stock: true,
      gXrStock: true,
      gXStock: true,
      gXSStock: true,
      g11Stock: true,
      g11PStock: true,
      g12Stock: true,
      g12PStock: true,
      gNote8Stock: true,
      gS8Stock: true,
      gPixel2Stock: true,
      gPixel3Stock: true,
      gPixel3aStock: true,
      gPixel4Stock: true,
      chargersStock: true,
      touchToolStock: true,

      // case in cart?
      has6: false,
      has7: false,
      has8: false,
      hasX: false,
      hasXS: false,
      hasXr: false,
      has11: false,
      has11P: false,
      has12: false,
      has12P: false,
      hasS8: false,
      hasPixel2: false,
      hasPixel3: false,
      hasPixel3a: false,
      hasPixel4: false,
      hasNote8: false,

      // upsell in cart
      has6g: false,
      has7g: false,
      has8g: false,
      hasXrg: false,
      hasXg: false,
      hasXSg: false,
      has11g: false,
      has11Pg: false,
      has12g: false,
      has12Pg: false,
      hasS8g: false,
      hasPixel2g: false,
      hasPixel3g: false,
      hasPixel3ag: false,
      hasPixel4g: false,
      hasNote8g: false,
      hasChargers: false,
      hasTouchTool: false,

      setListeners: function setListeners() {
        var u = Peel.upsellDirector;

        $('#checkout').on('click', function (e) {
          e.preventDefault();

          // Touch Tool
          if (u.hasTouchTool) {
            window.location = '/pages/touch-tool-upsell';
            return;
          }

          // iPhone 11
          if (u.has11 && !u.has11g && u.g11Stock) {
            window.location = '/pages/add-iphone-11-screen-protector';
            return;
          }

          // iPhone 11 Pro
          if (u.has11P && !u.has11Pg && u.g11PStock) {
            window.location = '/pages/add-iphone-11-pro-screen-protector';
            return;
          }

          // iPhone 12
          if (u.has12 && !u.has12g && u.g12Stock) {
            window.location = '/pages/add-iphone-12-screen-protector';
            return;
          }

          // iPhone 12 Pro
          if (u.has12P && !u.has12Pg && u.g12PStock) {
            window.location = '/pages/add-iphone-12-pro-screen-protector';
            return;
          }

          // XS
          if (u.hasXS && !u.hasXSg && u.gXSStock) {
            window.location = '/pages/add-iphone-xs-screen-protector';
            return;
          }

          if (u.hasXr && !u.hasXrg && u.gXrStock) {
            window.location = '/pages/add-iphone-xr-screen-protector';
            return;
          }

          // X
          if (u.hasX && !u.hasXg && u.gXStock) {
            window.location = '/pages/add-iphone-x-screen-protector';
            return;
          }

          // 8
          else if (u.has8 && !u.has8g && u.g8Stock) {
            window.location = '/pages/add-iphone-8-screen-protector';
            return;
          }

          // 7
          else if (u.has7 && !u.has7g && u.g7Stock) {
            window.location = '/pages/add-iphone-7-screen-protector';
            return;
          }

          // 6
          else if (u.has6 && !u.has6g && u.g6Stock) {
            window.location = '/pages/add-iphone-6s-screen-protector';
            return;
          }

          // S8
          else if (u.hasS8 && !u.hasS8g && u.gS8Stock) {
            window.location = '/pages/add-galaxy-s8-screen-protector';
            return;
          }

          // Note8
          else if (u.hasNote8 && !u.hasNote8g && u.gNote8Stock) {
            window.location = '/pages/add-galaxy-note8-screen-protector';
            return;
          }

          // Pixel 2
          else if (u.hasPixel2 && !u.hasPixel2g && u.gPixel2Stock) {
            window.location = '/pages/add-pixel-2-screen-protector';
            return;
          }

          // Pixel 3
          else if (u.hasPixel3 && !u.hasPixel3g && u.gPixel3Stock) {
            window.location = '/pages/add-pixel-3-screen-protector';
            return;
          }

          // Pixel 3a
          else if (u.hasPixel3a && !u.hasPixel3ag && u.gPixel3aStock) {
            window.location = '/pages/add-pixel-3a-screen-protector';
            return;
          }

          // Pixel 4
          else if (u.hasPixel4 && !u.hasPixel4g && u.gPixel4Stock) {
            window.location = '/pages/add-pixel-4-screen-protector';
            return;
          }

          // Chargers
          else if (!u.hasChargers && u.chargersStock) {
            if (u.has6g || u.has7g || u.has8g || u.hasXg || u.has8 || u.has7 || u.has6 || u.hasX) {
              window.location = '/pages/add-chargers';
              return;
            } else {
              window.location = '/checkout';
              return;
            }
          } else {
            window.location = '/checkout';
            return;
          }

          // if (Peel.upsellDirector.has7 && !Peel.upsellDirector.hasGlass && Peel.upsellDirector.glass7Stock) {
          //     e.preventDefault()
          //     window.location = '/pages/add-iphone-7-screen-protector'
          // } else if (Peel.upsellDirector.has6 && !Peel.upsellDirector.hasGlass && Peel.upsellDirector.glass6Stock) {
          //     e.preventDefault()
          //     window.location = '/pages/add-iphone-6s-screen-protector'
          // } else if (
          //     !Peel.upsellDirector.hasChargers &&
          //     Peel.upsellDirector.chargersStock &&
          //     (Peel.upsellDirector.has6 || Peel.upsellDirector.has7)
          // ) {
          //     e.preventDefault()
          //     window.location = '/pages/add-chargers'
          // }
        });
      },

      stockCheck: function stockCheck() {
        var g6 = up6['variants'];
        var g7 = up7['variants'];
        var g8 = up8['variants'];
        var gX = upX['variants'];
        var gXS = upXS['variants'];
        var gXr = upXr['variants'];
        var g11 = up11['variants'];
        var g11P = up11P['variants'];
        var g12 = up12['variants'];
        var g12P = up12P['variants'];
        var gS8 = upS8['variants'];
        var gNote8 = upNote8['variants'];
        var gPixel2 = upPixel2['variants'];
        var gPixel3 = upPixel3['variants'];
        var gPixel3a = upPixel3a['variants'];
        var gPixel4 = upPixel4['variants'];
        var charge = upChargers['variants'];
        var touchTool = upTouchTool['variants'];


        // 6 stock
        for (var i = 0; i < g6.length; i++) {
          var inventory = g6[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g6Stock = false;
            break;
          }
        }

        // 7 stock
        for (var i = 0; i < g7.length; i++) {
          var inventory = g7[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g7Stock = false;
            break;
          }
        }

        // 8 stock
        for (var i = 0; i < g8.length; i++) {
          var inventory = g8[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g8Stock = false;
            break;
          }
        }

        // X stock
        for (var i = 0; i < gX.length; i++) {
          var inventory = gX[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gXStock = false;
            break;
          }
        }

        // XS stock
        for (var i = 0; i < gXS.length; i++) {
          var inventory = gXS[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gXSStock = false;
            break;
          }
        }

        // iP 11 stock
        for (var i = 0; i < g11.length; i++) {
          var inventory = g11[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g11Stock = false;
            break;
          }
        }

        // iP 11P stock
        for (var i = 0; i < g11P.length; i++) {
          var inventory = g11P[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g11PStock = false;
            break;
          }
        }

        // iP 12 stock
        for (var i = 0; i < g12.length; i++) {
          var inventory = g12[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g12Stock = false;
            break;
          }
        }

        // iP 12P stock
        for (var i = 0; i < g12P.length; i++) {
          var inventory = g12P[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g12PStock = false;
            break;
          }
        }

        // 9 stock
        for (var i = 0; i < gXr.length; i++) {
          var inventory = gXr[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.g9Stock = false;
            break;
          }
        }

        // S8 stock
        for (var i = 0; i < gS8.length; i++) {
          var inventory = gS8[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gS8Stock = false;
            break;
          }
        }

        // Note8 stock
        for (var i = 0; i < gNote8.length; i++) {
          var inventory = gNote8[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gNote8Stock = false;
            break;
          }
        }

        // Pixel 2 stock
        for (var i = 0; i < gPixel2.length; i++) {
          var inventory = gPixel2[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gPixel2Stock = false;
            break;
          }
        }

        // Pixel 3 stock
        for (var i = 0; i < gPixel3.length; i++) {
          var inventory = gPixel3[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gPixel3Stock = false;
            break;
          }
        }

        // Pixel 3a stock
        for (var i = 0; i < gPixel3a.length; i++) {
          var inventory = gPixel3a[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gPixel3aStock = false;
            break;
          }
        }

        // Pixel 4 stock
        for (var i = 0; i < gPixel4.length; i++) {
          var inventory = gPixel4[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.gPixel4Stock = false;
            break;
          }
        }

        // Chargers stock
        for (var i = 0; i < charge.length; i++) {
          var inventory = charge[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.chargersStock = false;
            break;
          }
        }

        // Touch Tool stock
        for (var i = 0; i < touchTool.length; i++) {
          var inventory = touchTool[i]['inventory_quantity'];

          if (inventory < 1) {
            Peel.upsellDirector.touchToolStock = false;
            break;
          }
        }

      },

      resetItems: function resetItems() {

        // case in cart with iP 12 Pro Max, iP 12 Mini?
        Peel.upsellDirector.is12PM = false;
        Peel.upsellDirector.is12MN = false;

        // case in cart with iP 11 Pro Max?
        Peel.upsellDirector.is11PM = false;
        Peel.upsellDirector.isPixel3XL = false;
        Peel.upsellDirector.isPixel3aXL = false;
        Peel.upsellDirector.isPixel4XL = false;

        // case in cart?
        Peel.upsellDirector.has6 = false;
        Peel.upsellDirector.has7 = false;
        Peel.upsellDirector.has8 = false;
        Peel.upsellDirector.hasX = false;
        Peel.upsellDirector.hasXr = false;
        Peel.upsellDirector.hasXS = false;
        Peel.upsellDirector.has11 = false;
        Peel.upsellDirector.has11P = false;
        Peel.upsellDirector.has12 = false;
        Peel.upsellDirector.has12P = false;
        Peel.upsellDirector.hasS8 = false;
        Peel.upsellDirector.hasPixel2 = false;
        Peel.upsellDirector.hasPixel3 = false;
        Peel.upsellDirector.hasPixel3a = false;
        Peel.upsellDirector.hasPixel4 = false;
        Peel.upsellDirector.hasNote8 = false;

        // upsell in cart
        Peel.upsellDirector.has6g = false;
        Peel.upsellDirector.has7g = false;
        Peel.upsellDirector.has8g = false;
        Peel.upsellDirector.hasXg = false;
        Peel.upsellDirector.hasXSg = false;
        Peel.upsellDirector.hasXrg = false;
        Peel.upsellDirector.has11g = false;
        Peel.upsellDirector.has11Pg = false;
        Peel.upsellDirector.has12g = false;
        Peel.upsellDirector.has12Pg = false;
        Peel.upsellDirector.hasS8g = false;
        Peel.upsellDirector.hasPixel2g = false;
        Peel.upsellDirector.hasPixel3g = false;
        Peel.upsellDirector.hasPixel3ag = false;
        Peel.upsellDirector.hasPixel4g = false;
        Peel.upsellDirector.hasNote8g = false;
        Peel.upsellDirector.hasChargers = false;
        Peel.upsellDirector.hasTouchTool = false;
      },

      itemCheck: function itemCheck() {
        Peel.upsellDirector.resetItems();

        var items = CartJS.cart.items;

        for (var i = 0; i < items.length; i++) {
          var t = items[i]['title'].toLowerCase();
          var sku = items[i]['sku'].toLowerCase();

          // Check for touch tool upsell
          if (t.indexOf('touch tool') > -1) Peel.upsellDirector.hasTouchTool = true;

          // Check for cases with iP 11 Pro Max, Pixel 4 XL
          if (sku.indexOf('11pro_max') > -1) Peel.upsellDirector.is11PM = true;
          if (sku.indexOf('3xl') > -1) Peel.upsellDirector.isPixel3XL = true;
          if (sku.indexOf('3axl') > -1) Peel.upsellDirector.isPixel3aXL = true;
          if (sku.indexOf('4xl') > -1) Peel.upsellDirector.isPixel4XL = true;

          // Check for cases with iP 12 Pro Max, iP 12 Mini
          if (sku.indexOf('12pro_max') > -1 || sku.indexOf('12promax') > -1) Peel.upsellDirector.is12PM = true;
          if (sku.indexOf('12_mini') > -1) Peel.upsellDirector.is12MN = true;

          // Check for cases
          if (t.indexOf('s8/s8+ case') > -1) Peel.upsellDirector.hasS8 = true;
          if (t.indexOf('note8 case') > -1) Peel.upsellDirector.hasNote8 = true;
          if (t.indexOf('pixel 2 case') > -1) Peel.upsellDirector.hasPixel2 = true;
          if (t.indexOf('pixel 3 case') > -1) Peel.upsellDirector.hasPixel3 = true;
          if (t.indexOf('pixel 3a case') > -1) Peel.upsellDirector.hasPixel3a = true;
          if (t.indexOf('pixel 4 case') > -1) Peel.upsellDirector.hasPixel4 = true;
          if (t.indexOf('6/6s case') > -1) Peel.upsellDirector.has6 = true;
          if (t.indexOf('iphone 7 case') > -1) Peel.upsellDirector.has7 = true;
          if (t.indexOf('iphone 8 case') > -1) Peel.upsellDirector.has8 = true;
          if (t.indexOf('iphone 8 / iphone se (2020) case') > -1) Peel.upsellDirector.has8 = true;
          if (t.indexOf('x case') > -1) Peel.upsellDirector.hasX = true;
          if (t.indexOf('xs case') > -1) Peel.upsellDirector.hasXS = true;
          if (t.indexOf('xr case') > -1) Peel.upsellDirector.hasXr = true;
          if (t.indexOf('11 case') > -1) Peel.upsellDirector.has11 = true;
          if (t.indexOf('11 pro case') > -1) Peel.upsellDirector.has11P = true;
          if (t.indexOf('12 case') > -1) Peel.upsellDirector.has12 = true;
          if (t.indexOf('12 pro case') > -1) Peel.upsellDirector.has12P = true;

          if (t.indexOf('chargers') > -1) Peel.upsellDirector.hasChargers = true;
          if (t.indexOf('s8/s8+ peel glass') > -1) Peel.upsellDirector.hasS8g = true;
          if (t.indexOf('note8 peel glass') > -1) Peel.upsellDirector.hasNote8g = true;
          if (t.indexOf('pixel 2 peel glass') > -1) Peel.upsellDirector.hasPixel2g = true;
          if (t.indexOf('pixel 3 peel glass') > -1) Peel.upsellDirector.hasPixel3g = true;
          if (t.indexOf('pixel 3a peel glass') > -1) Peel.upsellDirector.hasPixel3ag = true;
          if (t.indexOf('pixel 4 peel glass') > -1) Peel.upsellDirector.hasPixel4g = true;
          if (t.indexOf('6/6s peel glass') > -1) Peel.upsellDirector.has6g = true;
          if (t.indexOf('iphone 7 peel glass') > -1) Peel.upsellDirector.has7g = true;
          if (t.indexOf('iphone 8 peel glass') > -1) Peel.upsellDirector.has8g = true;
          if (t.indexOf('iphone xr peel glass') > -1) Peel.upsellDirector.hasXrg = true;
          if (t.indexOf('x peel glass') > -1) Peel.upsellDirector.hasXg = true;
          if (t.indexOf('xs peel glass') > -1) Peel.upsellDirector.hasXSg = true;
          if (t.indexOf('11 peel glass') > -1) Peel.upsellDirector.has11g = true;
          if (t.indexOf('11 pro peel glass') > -1) Peel.upsellDirector.has11Pg = true;
          if (t.indexOf('12 peel glass') > -1) Peel.upsellDirector.has12g = true;
          if (t.indexOf('12 pro peel glass') > -1) Peel.upsellDirector.has12Pg = true;
        }
      },

      init: function init() {
        this.stockCheck();
        this.itemCheck();
        this.setListeners();
      }
    };

    $(document).on('cart.ready', function (event, cart) {
      Peel.upsellDirector.init();
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      Peel.upsellDirector.itemCheck();
    });

    /***/ }),
  /* 12 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    /* global Peel, $ */

    Peel.selfRefer = {
      urlCheck: function urlCheck() {
        var url = window.location.href;

        if (url.indexOf('self-referral=true') > 0) {
          return true;
        }
      },

      setListeners: function setListeners() {
        $('.self-refer__white').on('click', function (e) {
          e.stopPropagation();
        });

        $('.self-refer').on('click', function () {
          $(this).removeClass('self-refer--active');
        });
      },

      init: function init() {
        if (this.urlCheck()) {
          $('.self-refer').addClass('self-refer--active');
        }
      }
    };

    $(document).ready(function () {
      Peel.selfRefer.init();
      Peel.selfRefer.setListeners();
    });

    /***/ }),
  /* 13 */
  /***/ (function(module, exports, __webpack_require__) {

    "use strict";


    function showNote(total) {

      // Hide all cart notes
      $('.in-cart-note').hide();

      // We'll need upsell data
      var u = Peel.upsellDirector;

      if (total < 3500) {
        $('.in-cart-shortage').text(Shopify.formatMoney(3500 - total, Shopify.money_format));
        console.log(u);

        // X
        if (u.hasXS && !u.hasXSg && u.gXSStock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-xs-peel-glass-screen-protector');
        } else if (u.hasXr && !u.hasXrg && u.gXrStock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-9-peel-glass-screen-protector');
        } else if (u.hasX && !u.hasXg && u.gXStock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-x-screen-protector');
        } else if (u.has11 && !u.has11g && u.g11Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-11-peel-glass-screen-protector');
        } else if (u.has11P && !u.has11Pg && u.g11PStock) {
          $('.in-cart-note.case').show();
          if(u.is11PM){
            $('.in-cart-anchor').attr('href', '/products/iphone-11-pro-peel-glass-screen-protector?variant=29505896120403');
          }else{
            $('.in-cart-anchor').attr('href', '/products/iphone-11-pro-peel-glass-screen-protector');
          }
        }else if (u.has12 && !u.has12g) {
          $('.in-cart-note.case').show();
          if(u.is12MN){
            $('.in-cart-anchor').attr('href', '/products/iphone-12-peel-glass-screen-protector?variant=32272170123347');
          }else{
            $('.in-cart-anchor').attr('href', '/products/iphone-12-peel-glass-screen-protector?variant=32272170156115');
          }
        }else if (u.has12P && !u.has12Pg) {
          $('.in-cart-note.case').show();
          if(u.is12PM){
            $('.in-cart-anchor').attr('href', '/products/iphone-12-pro-peel-glass-screen-protector?variant=32272186638419');
          }else{
            $('.in-cart-anchor').attr('href', '/products/iphone-12-pro-peel-glass-screen-protector');
          }
        } else if (u.has8 && !u.has8g && u.g8Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-8-screen-protector');
        } else if (u.has7 && !u.has7g && u.g7Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-7-screen-protector');
        } else if (u.has6 && !u.has6g && u.g6Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/iphone-6s-screen-protector');
        } else if (u.hasS8 && !u.hasS8g && u.gS8Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/galaxy-s8-peel-glass-screen-protector');
        } else if (u.hasNote8 && !u.hasNote8g && u.gNote8Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/galaxy-note8-peel-glass-screen-protector');
        } else if (u.hasPixel2 && !u.hasPixel2g && u.gPixel2Stock) {
          $('.in-cart-note.case').show();
          $('.in-cart-anchor').attr('href', '/products/pixel-2-peel-glass-screen-protector');
        } else if (u.hasPixel3 && !u.hasPixel3g && u.gPixel3Stock) {
          $('.in-cart-note.case').show();
          if(u.isPixel3XL){
            $('.in-cart-anchor').attr('href', '/products/pixel-3-peel-glass-screen-protector?variant=21480126578771');
          }else{
            $('.in-cart-anchor').attr('href', '/products/pixel-3-peel-glass-screen-protector');
          }
        } else if (u.hasPixel3a && !u.hasPixel3ag && u.gPixel3aStock) {
          $('.in-cart-note.case').show();
          if(u.isPixel3aXL){
            $('.in-cart-anchor').attr('href', '/products/pixel-3a-peel-glass-screen-protector?variant=29414883229779');
          }else{
            $('.in-cart-anchor').attr('href', '/products/pixel-3a-peel-glass-screen-protector');
          }
        } else if (u.hasPixel4 && !u.hasPixel4g && u.gPixel4Stock) {
          $('.in-cart-note.case').show();
          if(u.isPixel4XL){
            $('.in-cart-anchor').attr('href', '/products/pixel-4-peel-glass-screen-protector?variant=30712861327443');
          }else{
            $('.in-cart-anchor').attr('href', '/products/pixel-4-peel-glass-screen-protector');
          }
        } else if (!u.has12P && u.has12Pg) {
          // 12 Pro Max
          $('.in-cart-note.protector').show();
          if(u.is12PM){
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-12-pro-case?variant=32232118485075');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-12-pro-case');
          }
        }else if (!u.has12 && u.has12g) {
          // 12 Mini
          $('.in-cart-note.protector').show();
          if(u.is12MN){
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-12-case');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-12-case?variant=32232257716307');
          }
        }else if (!u.has11P && u.has11Pg) {
          // 11 Pro
          $('.in-cart-note.protector').show();
          if(u.is11PM){
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-11-pro-case?variant=29496462049363');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-11-pro-case');
          }
        } else if (!u.has11 && u.has11g) {
          // 11
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-11-case?variant=29496667177043');
        } else if (!u.hasX && u.hasXg) {
          // X
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-x-case');
        } else if (!u.has8 && u.has8g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-8-case');
        } else if (!u.has7 && u.has7g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-7-case?variant=29716430471');
        } else if (!u.has6 && u.has6g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-iphone-6s-case?variant=16303129223');
        } else if (!u.hasS8 && u.hasS8g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-galaxy-s8-s8-plus-case');
        } else if (!u.hasNote8 && u.hasNote8g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-galaxy-note8-case');
        } else if (!u.hasPixel2 && u.hasPixel2g) {
          $('.in-cart-note.protector').show();
          $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-2-case');
        } else if (!u.hasPixel3 && u.hasPixel3g) {
          $('.in-cart-note.protector').show();
          if(u.isPixel3XL){
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-3-case?variant=21242726809683');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-3-case');
          }
        } else if (!u.hasPixel3a && u.hasPixel3ag) {
          $('.in-cart-note.protector').show();
          if(u.isPixel3aXL){
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-3a-case?variant=29424323330131');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-3a-case');
          }
        } else if (!u.hasPixel4 && u.hasPixel4g) {
          $('.in-cart-note.protector').show();
          if(u.isPixel4XL){
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-4-case?variant=30712851791955');
          }else{
            $('.in-cart-anchor').attr('href', '/products/super-thin-pixel-4-case');
          }
        }else{
          $('.in-cart-note.no-suggest').show();
        }
      } else {
        $('.in-cart-note.good').show();
      }

    }

    function showAddAnotherForFree (item_count) {
      // We'll need upsell data
      var items = CartJS.cart.items;
      var countNotCaseGlass = 0;
      for (var i = 0; i < items.length; i++) {
        var t = items[i]['title'].toLowerCase();
        // Check if item is not contains cases or glass, after plus 1
        if (t.indexOf('case') > -1) countNotCaseGlass += items[i]['quantity'];
        if (t.indexOf('glass') > -1) countNotCaseGlass += items[i]['quantity'];
      }

      if (parseInt(countNotCaseGlass) % 2 === 0 && parseInt(countNotCaseGlass) > 1) { 
        /* we are even */ 
        $('.in-cart-note.good-add-another').show();
        $('.in-cart-note.add-another-for-free').hide();
      }else { 
        /* we are odd */ 
        $('.in-cart-note.good-add-another').hide();
        $('.in-cart-note.add-another-for-free').show();
      }  

      if(countNotCaseGlass == 0){
        $('.in-cart-note.good-add-another').hide();
        $('.in-cart-note.add-another-for-free').hide();
      }
    }

    $(document).on('cart.ready', function (event, cart) {
      var IP_API = 'https://get.geojs.io/v1/ip/geo.json';
      $.getJSON(IP_API, function (data) {
        if (data.country_code == 'US' || data.country_code == 'VN' ) {
          showNote(cart.total_price);
          $('.note_check_shipping').hide();
        } 
      });     
      showAddAnotherForFree(cart.item_count);
    });

    $(document).on('cart.requestComplete', function (event, cart) {
      var IP_API = 'https://get.geojs.io/v1/ip/geo.json';
      $.getJSON(IP_API, function (data) {
        if (data.country_code == 'US' || data.country_code == 'VN') {
          showNote(cart.total_price);
          $('.note_check_shipping').hide();
        } 
      });
      showAddAnotherForFree(cart.item_count);
    });

    /***/ })
  /******/ ]);